import { Component, OnDestroy } from "@angular/core";
import { AppConstants } from "../../app.constant";
import { ToolbarEvent } from "../../core/events/toolbar.event";
import { Subscription } from "rxjs/Subscription";
declare var require: any;

@Component({
  selector: "ixs-loader",
  templateUrl: "ixsloader.component.html",
  styleUrls: ["ixsloader.css"]
})
export class IxsloaderComponent implements OnDestroy {
  private toolbarSubscription: Subscription;
  eduManlogoUrl: string = require("assets/Images/newloader.gif");
  isLoading = false;

  constructor() {
    const toolbarEvent = AppConstants.injector.get(ToolbarEvent);

    this.toolbarSubscription = toolbarEvent.click().subscribe(arg => {
      if (arg.key === "start") {
        this.startLoading();
      } else if (arg.key === "stop") {
        this.stopLoading();
      }
    });
  }

  startLoading() {
    this.isLoading = true;
  }

  stopLoading() {
    this.isLoading = false;
  }

  ngOnDestroy() {
    if (this.toolbarSubscription) {
      this.toolbarSubscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/ixsloader/ixsloader.component.ts